"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useQueryClient } from "@tanstack/react-query";
import TrailerModal from "@/components/modals/TrailerModal";
import Button from "@/components/ui/Button";
import LinkButton from "@/components/ui/Link";
import { PlayFill, PlayFillWhite } from "@/lib/icons";
import { useUserStore } from "@/stores/useAuthStore";
import { usePlaybackHref } from "@/hooks/usePlaybackHref";
import { savePlaybackOrigin } from "@/lib/playbackOrigin";
import type { StaticImageData } from "next/image";
import defaultPoster from '../../../../public/suppression.jpg';
interface BackgroundImages {
  mobile?: string;
  tablet?: string;
  desktop?: string;
}
interface Props {
  onBuyClick?: () => void;
  uuid: string;
  title?: string;
  uniqueCode?: string;
  lastEpisodeUuid?: string;
  status?: string;
  traileruuid?: string;
  poster?: BackgroundImages;
  hasActiveSubscription?: boolean;
  hasActiveTicket?: boolean;
  comingSoon?: boolean;
  episodesLoading?: boolean;
}
export default function MovieActions(t0) {
  const $ = _c(31);
  const {
    onBuyClick,
    uuid,
    title,
    uniqueCode,
    lastEpisodeUuid,
    status,
    poster,
    traileruuid,
    hasActiveSubscription,
    hasActiveTicket,
    comingSoon,
    episodesLoading
  } = t0;
  const [openTrailer, setOpenTrailer] = useState(false);
  const [mounted, setMounted] = useState(false);
  const router = useRouter();
  const queryClient = useQueryClient();
  const {
    isLoggedIn
  } = useUserStore();
  let t1;
  let t2;
  if ($[0] !== queryClient) {
    t1 = () => {
      setMounted(true);
      queryClient.invalidateQueries({
        queryKey: ["my-subscription"]
      });
      queryClient.invalidateQueries({
        queryKey: ["my-purchased-tickets"]
      });
    };
    t2 = [queryClient];
    $[0] = queryClient;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isLoggedIn || $[4] !== router) {
    t3 = () => {
      if (isLoggedIn) {
        router.push(`/account/plans?from=${encodeURIComponent(window.location.pathname)}`);
      } else {
        router.push(`/login?returnTo=${encodeURIComponent(window.location.pathname)}`);
      }
    };
    $[3] = isLoggedIn;
    $[4] = router;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleBuySubscription = t3;
  const getPosterSrc = _temp;
  const background = poster?.desktop ?? poster?.tablet ?? poster?.mobile ?? defaultPoster;
  let t4;
  if ($[6] !== background) {
    t4 = getPosterSrc(background);
    $[6] = background;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const backgroundSrc = t4;
  let t5;
  if ($[8] !== backgroundSrc || $[9] !== lastEpisodeUuid || $[10] !== title || $[11] !== uuid) {
    t5 = () => {
      const playbackUuid = lastEpisodeUuid || uuid;
      if (playbackUuid) {
        localStorage.setItem(`movieposter:${playbackUuid}`, backgroundSrc);
        if (title) {
          localStorage.setItem(`movietitle:${playbackUuid}`, title);
        }
        savePlaybackOrigin(playbackUuid, window.location.pathname);
      }
    };
    $[8] = backgroundSrc;
    $[9] = lastEpisodeUuid;
    $[10] = title;
    $[11] = uuid;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const savePoster = t5;
  const playbackTarget = lastEpisodeUuid ? `/ml/${lastEpisodeUuid}?series=${uuid}${uniqueCode ? `&code=${uniqueCode}` : ""}` : `/m/${uuid}`;
  const watchHref = usePlaybackHref(playbackTarget);
  let t6;
  if ($[13] !== comingSoon || $[14] !== episodesLoading || $[15] !== handleBuySubscription || $[16] !== hasActiveSubscription || $[17] !== hasActiveTicket || $[18] !== mounted || $[19] !== onBuyClick || $[20] !== savePoster || $[21] !== status || $[22] !== traileruuid || $[23] !== watchHref) {
    t6 = <div className="mt-8 flex w-full flex-wrap gap-3 sm:w-auto sm:flex-row sm:gap-4">{comingSoon ? <div className="flex items-center w-full gap-3"><Button variant="warning" size="md" className="w-2/4 sm:w-auto opacity-40 cursor-not-allowed pointer-events-none"><PlayFillWhite />به زودی</Button>{traileruuid && <Button onClick={() => {
          savePoster();
          setOpenTrailer(true);
        }} variant="blur" size="md" className="w-2/4 sm:w-auto"><PlayFillWhite />تماشای تریلر</Button>}</div> : mounted && (status?.toLowerCase() === "ticket" && hasActiveTicket || status?.toLowerCase() === "subscription" && hasActiveSubscription) ? <div className="flex items-center w-full gap-3"><LinkButton onClick={savePoster} href={watchHref} disabled={episodesLoading} variant="white" size="md" className="w-2/4 sm:w-auto"><PlayFill />تماشا</LinkButton>{traileruuid && <Button onClick={() => {
          savePoster();
          setOpenTrailer(true);
        }} variant="blur" size="md" className="w-2/4 sm:w-auto"><PlayFillWhite />تماشای تریلر</Button>}</div> : status?.toLowerCase() === "ticket" ? <Button onClick={onBuyClick} variant="danger" size="md" className="w-full sm:w-auto"><PlayFillWhite />خرید بلیط و تماشا</Button> : status?.toLowerCase() === "subscription" ? <div className="flex items-center w-full gap-3"><Button onClick={handleBuySubscription} variant="white" size="md" className="w-2/4 sm:w-auto"><PlayFill />خرید اشتراک</Button>{traileruuid && <Button onClick={() => {
          savePoster();
          setOpenTrailer(true);
        }} variant="blur" size="md" className="w-2/4 sm:w-auto"><PlayFillWhite />تماشای نسخه تریلر</Button>}</div> : <div className="flex items-center w-full gap-3"><LinkButton onClick={savePoster} href={watchHref} disabled={episodesLoading} variant="white" size="md" className="w-2/4 sm:w-auto"><PlayFill />تماشای رایگان</LinkButton>{traileruuid && <Button onClick={() => {
          savePoster();
          setOpenTrailer(true);
        }} variant="blur" size="md" className="w-2/4 sm:w-auto"><PlayFillWhite />تماشای نسخه تریلر</Button>}</div>}</div>;
    $[13] = comingSoon;
    $[14] = episodesLoading;
    $[15] = handleBuySubscription;
    $[16] = hasActiveSubscription;
    $[17] = hasActiveTicket;
    $[18] = mounted;
    $[19] = onBuyClick;
    $[20] = savePoster;
    $[21] = status;
    $[22] = traileruuid;
    $[23] = watchHref;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== openTrailer || $[26] !== traileruuid) {
    t7 = traileruuid && <TrailerModal open={openTrailer} trailerUuid={traileruuid} onClose={() => setOpenTrailer(false)} />;
    $[25] = openTrailer;
    $[26] = traileruuid;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t6 || $[29] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
}
function _temp(posterValue) {
  if (typeof posterValue === "string") {
    return posterValue;
  }
  return posterValue.src;
}